var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('galleryHost.replaceParticipant'),
      "visible": _vm.info.show,
      "width": "445px",
      "close-on-click-modal": false,
      "append-to-body": true,
      "before-close": _vm.close
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-tabs', {
    model: {
      value: _vm.activeName,
      callback: function ($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('galleryHost.seated'),
      "name": "Seated"
    }
  }, [_c('ul', {
    staticClass: "scrollbar"
  }, _vm._l(_vm.currentPageList, function (val) {
    return _c('li', {
      key: val.rtilCode,
      class: {
        active: _vm.activeVal == val.rtilCode
      },
      on: {
        "click": function ($event) {
          return _vm.select(val);
        }
      }
    }, [_vm.activeVal == val.rtilCode ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.nickName[val.rtilCode] || val.nickName || val.memberId) + " " + _vm._s(_vm.tagName[val.rtilCode] || val.tagName ? ` / ${_vm.tagName[val.rtilCode] || val.tagName}` : '') + " ")]);
  }), 0)]), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('galleryHost.waiting'),
      "name": "Waiting"
    }
  }, [_c('ul', {
    staticClass: "scrollbar"
  }, _vm._l(_vm.alternateList, function (val) {
    return _c('li', {
      key: val.rtilCode,
      class: {
        active: _vm.activeVal == val.rtilCode
      },
      on: {
        "click": function ($event) {
          return _vm.select(val);
        }
      }
    }, [_vm.activeVal == val.rtilCode ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(_vm._s(val.nickName || val.memberId) + _vm._s(_vm.tagName[val.rtilCode] || val.tagName ? ` / ${_vm.tagName[val.rtilCode] || val.tagName}` : '') + " ")]);
  }), 0)])], 1), (_vm.activeName == 'Seated' ? !_vm.currentPageList.length : !_vm.alternateList.length) ? _c('div', {
    staticClass: "no-data"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('galleryHost.noParticipant')))])]) : _vm._e(), _c('div', {
    staticClass: "border"
  })], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "cancel",
    class: _vm.showOkClass,
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.btnText))]), _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.save
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.replace')))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };